<template lang="pug">
  v-row
    v-col(cols="12")
      h1.mb-6 Профиль пользователя {{ userData.name }}
      p ФИО: {{ userData.info.full_name }}
      p E-mail: {{ userData.email || 'Не указан' }}
      p Состоит в организациях:
        li(v-for="org in userData.organizations") {{ org.full_name }} ({{ getRoleName(org.role) }})
</template>

<script>
import { mapGetters } from 'vuex';
import { getRoleName } from '@/modules/Auth/constants';

export default {
  name: 'UserProfile',
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({ userData: 'auth/userData' }),
  },
  methods: {
    getRoleName,
  },
};
</script>

<style lang="scss" scoped>

</style>
